import React from 'react'
import {
  Select,
  Radio,
  Checkbox,
  Input,
  InputNumber
  // DatePicker,
  // TimePicker
} from 'antd'
import DatePickerDropDown from '~/App/components/DatePickerDropDown'
import localeGet from '~/App/utils/localeGet'
const date = ({ question, locale, ...props }) => (
  <DatePickerDropDown {...props} />
)

const select = ({ question, locale, ...props }, containerRefFn) => (
  <Select {...props} placeholder={localeGet(question, 'name', locale)} getPopupContainer={containerRefFn}>
    {question.items.map((item, itemIndex) => (
      <Select.Option key={item._id} value={item._id}>
        {localeGet(item, 'value', locale)}
      </Select.Option>
    ))}
  </Select>
)

const radio = ({ question, locale, ...props }) => (
  <Radio.Group {...props}>
    {question.items.map((item, itemIndex) => (
      <Radio key={item._id} value={item._id}>
        <span style={{ whiteSpace: 'pre-line' }}>
          {localeGet(item, 'value', locale)}
        </span>
      </Radio>
    ))}
  </Radio.Group>
)

const checkbox = ({ question, locale, ...props }) => (
  <Checkbox key={question.items[0]._id} {...props}>
    {localeGet(question.items[0], 'value', locale)}
  </Checkbox>
)

const checkboxes = ({ question, locale, ...props }) => (
  <Checkbox.Group {...props}>
    {question.items.map((item, itemIndex) => (
      <div key={item._id}>
        <Checkbox key={item._id} value={item._id}>
          {localeGet(item, 'value', locale)}
        </Checkbox>
      </div>
    ))}
  </Checkbox.Group>
)

const text = ({ question, locale, ...props }) => (
  <Input type="text" {...props} />
)

const hidden = ({ question, locale, ...props }) => (
  <div></div>
)

const textarea = ({ question, locale, ...props }) => (
  <Input.TextArea {...props} rows={4} />
)

const number = ({ question, locale, ...props }) => <InputNumber {...props} />

// const date = ({ question, locale, ...props }) => <DatePicker {...props} />
// const datetime = ({ question, locale, ...props }) => <DatePicker {...props} />
// const time = ({ question, locale, ...props }) => <TimePicker {...props} />

const multiselect = ({ question, locale, ...props }, containerRefFn) => (
  <Select mode="multiple" {...props} getPopupContainer={containerRefFn}>
    {question.items.map((item, itemIndex) => (
      <Select.Option key={item._id} value={item._id}>
        {localeGet(item, 'value', locale)}
      </Select.Option>
    ))}
  </Select>
)

class DurationInput extends React.Component {
  state = {
    hours: 0,
    minutes: 0
  }
  handleHourChange = (hours) => {
    // console.log({ hours })
    this.setState({
      hours
    }, () => {
      const { hours, minutes } = this.state
      const hh = ('0' + hours).slice(-2)
      const mm = ('0' + minutes).slice(-2)
      this.props.onChange(`${hh}:${mm}`)
    })
  }
  handleMinuteChange = (minutes) => {
    // console.log({ minutes })
    this.setState({
      minutes
    }, () => {
      const { hours, minutes } = this.state
      const hh = ('0' + hours).slice(-2)
      const mm = ('0' + minutes).slice(-2)
      this.props.onChange(`${hh}:${mm}`)
    })
  }
  componentWillMount () {
    const { value } = this.props
    const time = value || '00:00'
    // console.log('receive', { value, time, defaultValue })
    const [hours, minutes] = time.split(':')
    this.setState({
      hours: parseInt(hours || 0, 10),
      minutes: parseInt(minutes || 0, 10)
    })
  }
  componentWillReceiveProps (nextProps) {
    // const { value, defaultValue } = nextProps
    // const time = value || '00:00'
    // console.log('receive', { value, time, defaultValue })
    // const [hours, minutes] = time.split(':')
    // this.setState({
    //   hours: parseInt(hours || 0, 10),
    //   minutes: parseInt(minutes || 0, 10)
    // })
  }
  render () {
    const { locale } = this.props
    const { hours, minutes } = this.state
    return <Input.Group compact>
      <InputNumber
        onChange={this.handleHourChange}
        value={hours}
        min={0}
        max={23}
        formatter={value => ('0' + value).slice(-2)}
        style={{ width: 60, textAlign: 'right' }}
      />
      <Input style={{ width: 10, padding: 0, borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff' }} placeholder=":" disabled />
      <InputNumber
        onChange={this.handleMinuteChange}
        value={minutes}
        min={0}
        max={59}
        formatter={value => ('0' + value).slice(-2)}
        style={{ width: 60, textAlign: 'right', borderLeft: 0 }}
      />
      <Input style={{ width: 100, pointerEvents: 'none', backgroundColor: '#fff' }} placeholder={{ en: 'hour:minutes', th: 'ชั่วโมง:นาที', zh: 'hour:minutes' }[locale]} disabled />
    </Input.Group>
  }
}

const duration = ({ question, locale, ...props }) => <DurationInput locale={locale} {...props} />
const heading = ({ question, locale, ...props }) => <div />

const rendererMap = {
  select,
  radio,
  checkbox,
  checkboxes,
  text,
  textarea,
  number,
  multiselect,
  duration,
  date,
  heading,
  hidden
}

const renderQuestionInput = (props, containerRefFn) =>
  rendererMap[props.question.inputType](props, containerRefFn)
// console.log('props.inputKey', props.inputKey)
// console.log('props.key', props.key)
// console.log('props.question', props.question)

export default renderQuestionInput



// WEBPACK FOOTER //
// ./src/renderQuestionInput.js